import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Consultorio } from '@/features/config/Consultorio'

/**
 * Consultório. A volta do consentimento da Google cai aqui com `?google=`,
 * porque é nesta tela que o cartão da agenda mostra o resultado. `motivo`
 * separa "você cancelou" de "demorou demais" de falha.
 */
export const Route = createFileRoute('/_app/app/config/consultorio')({
  validateSearch: z.object({
    google: z.enum(['ok', 'erro']).optional(),
    motivo: z.enum(['negado', 'expirou']).optional().catch(undefined),
  }),
  component: function ConsultorioRoute() {
    const { google, motivo } = Route.useSearch()
    return <Consultorio retorno={google} motivo={motivo} />
  },
})
